<template>
  <div style="padding:20px;">
    <el-row style="margin-bottom:15px;">
      <el-button type="primary" @click="getData" icon="refresh">刷新</el-button>
    </el-row>
    <el-table :data="orgUnits" tooltip-effect="dark" border stripe height="calc(100vh - 190px)"
      row-key="id" default-expand-all v-loading="loading">
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="name" label="名称" :min-width="200" show-overflow-tooltip>
        <template #="{row}">
            <el-tag size="small" v-if="row.unitId" type="success">部门</el-tag>
            <el-tag size="small" v-else-if="row.orgId">公司</el-tag>
            <el-tag size="small" v-else type="danger">人员</el-tag>
          <span style="margin-left: 5px;">{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="{row}">
          <div  v-if="!row.orgId && !row.unitId">
            <el-tag v-if="row.auditStatus === 0">待审核</el-tag>
            <el-tag v-else-if="row.auditStatus === 1 && row.userOrgOrUnitId" type="success">审核通过</el-tag>
            <el-tag v-else-if="row.auditStatus && row.userOrgOrUnitId" type="danger">已删除</el-tag>
            <el-tag v-else-if="row.auditStatus === 2" type="warning">审核驳回</el-tag>
            <el-tag v-else type="success">审核通过</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="80">
        <template #default="{row}">
          <el-button type="text" @click="toInfo(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <org-info v-model="orgVisible" :orgUnit="orgUnit" />
    <unit-info v-model="unitVisible" :orgUnit="orgUnit" />
  </div>
</template>

<script>
import { getOrgUnitUserTreeByOrgId } from '@/api/sys/org';
import { defineComponent } from 'vue';
import XLSX from 'xlsx';

import OrgInfo from './OrgInfo.vue';
import UnitInfo from './UnitInfo.vue';

export default defineComponent({
  components: { OrgInfo, UnitInfo },
  props: {
    id: String,
    currColumnValue: Number
  },
  data() {
    return {
      apply: {},
      dialogVisible: false,
      orgUnits: [],
      orgUnit: {},
      orgVisible: false,
      unitVisible: false,
      tableColumns: [
        { prop: 'briefName', label: '简称', width: 120, tooltip: true },
        { prop: 'count', label: '成员数', width: 75 },
        { prop: 'contactName', label: '联系人', minWidth: 120 },
        { prop: 'contactPhone', label: '联系电话', width: 120 }
      ],
      loading: false
    }
  },
  methods: {
    getData() {
      this.loading = true;
      getOrgUnitUserTreeByOrgId(this.id).then(({data}) => {
        this.orgUnits = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    toExportUser() { // 导出人员
      let userData = []
      this.getUserExportData(this.orgUnits, userData, {})
            
      let filename = this.orgUnits[0].name + "人员.xlsx"; //文件名称
      let wb = XLSX.utils.book_new(),
          ws = XLSX.utils.json_to_sheet(userData);
      XLSX.utils.book_append_sheet(wb, ws, '人员');  //将数据添加到工作薄
      XLSX.writeFile(wb, filename);

    },
    getUserExportData(orgUnits, users, parent) { // 遍历生成导出数据
      orgUnits.forEach(ou => {
        if (!ou.unitId && !ou.orgId) {
          users.push({'姓名': ou.name, '电话': ou.contactPhone, '部门': parent.name});
        } else if (ou.children) {
          this.getUserExportData(ou.children, users, ou);
        }
      })
    },
    toInfo(row) {
      this.orgUnit = row;
      if (row.unitId) {
        this.unitVisible = true;
      } else if (row.orgId) {
        this.orgVisible = true;
      } else {
        this.$router.push(`/sys/user/info?id=${row.id}`)
      }
    }
  },
  watch: {
    currColumnValue(val) {
      if (val === 2) {
        this.getData();
      }
    }
  }
})
</script>
